import PropTypes from 'prop-types';
import React, { useCallback } from 'react';

import cls from 'classnames';

import CheckIconSmall from '@ott/icon-small-check';
import CrossIconSmall from '@ott/icon-small-cross';

import styles from './Switcher.scss';

export const LABEL_POSITION = {
  RIGHT: 'right',
  LEFT: 'left',
};

const Switcher = React.forwardRef(
  (
    {
      className,
      isDisabled,
      isError,
      label,
      labelPosition,
      name,
      onChange,
      specificLocators,
      value: isSwitchedOn,
      childrenClassName = {},
    },
    ref
  ) => {
    // todo specify isError state
    const handleChange = useCallback(
      (event) => {
        if (isDisabled) {
          return;
        }
        onChange(event);
      },
      [isDisabled, onChange]
    );

    const inputElementIdentifier = name ? `switcher-for-${name}` : undefined;
    const labelNode = label ? (
      <span className={cls(styles.label, childrenClassName.label)}>{label}</span>
    ) : null;
    const IconComponent = isSwitchedOn ? CheckIconSmall : CrossIconSmall;
    return (
      <label
        className={cls(styles.Switcher, className, {
          [styles.active]: isSwitchedOn,
          [styles.disabled]: isDisabled,
        })}
        htmlFor={inputElementIdentifier}
        data-locator={specificLocators}
      >
        {labelPosition === LABEL_POSITION.LEFT && labelNode}
        <div className={cls(styles.shape, childrenClassName.shape)}>
          <input
            checked={isSwitchedOn}
            className={styles.input}
            id={inputElementIdentifier}
            name={name}
            onChange={handleChange}
            ref={ref}
            type="checkbox"
          />
          <div className={cls(styles.iconContainer, { [styles.adjustedToLeft]: isSwitchedOn })}>
            <IconComponent className={styles.icon} />
          </div>
        </div>
        {labelPosition === LABEL_POSITION.RIGHT && labelNode}
      </label>
    );
  }
);

Switcher.propTypes = {
  className: PropTypes.string,
  isDisabled: PropTypes.bool,
  label: PropTypes.string,
  labelPosition: PropTypes.oneOf(Object.values(LABEL_POSITION)),
  name: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.bool,
  specificLocators: PropTypes.oneOfType([PropTypes.array, PropTypes.string]),
  childrenClassName: PropTypes.shape({
    shape: PropTypes.string,
    label: PropTypes.string,
  }),
};

Switcher.defaultProps = {
  isDisabled: false,
  label: '',
  name: undefined,
  labelPosition: LABEL_POSITION.RIGHT,
  value: false,
};

export default Switcher;
